<template>

  <van-row class="rootcontent" @click="arrowClick">

    <van-col span="6" class="col-left">
      <van-image width="80" height="80" radius="3" :src="icon" />
    </van-col>
    <van-col span="16" class="col-center">

      <van-row class="content-title">
        {{title}}
      </van-row>
      <van-row class="content-subtitle">
        {{subtitle}}
      </van-row>
      <van-row class="content-price">
        ￥{{price}}
      </van-row>

    </van-col>
    <van-col span="2" class="col-right">
      <van-icon name="arrow" />
    </van-col>
  </van-row>

</template>

<script>
export default {
  name: "favouratecell",
  props: {
    id: {
      type: Number,
    },
    icon: {
      type: String,
      default: "https://img.yzcdn.cn/vant/cat.jpeg",
    },
    title: {
      type: String,
      default: "商品名称",
    },
    subtitle: {
      type: String,
      default: "",
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    arrowClick() {
      this.$emit("click", this.id);
    },
  },
};
</script>

<style scoped lang="scss">
.rootcontent {
  width: 100%;
  border-bottom: solid 1px lightgrey;
}

.col-left {
  height: 100px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
  background-color: transparent;
}
.col-center {
  background-color: transparent;
  padding-top: 10px;
  text-align: left;
  .content-title {
    line-height: 2rem;
    height: 40px;
    font-size: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .content-subtitle {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.2rem;
    color: gray;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .content-price {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.2rem;
    color: red;
  }
}
.col-right {
  height: 100px;
  /*flex 布局*/
  display: flex;
  /*实现垂直居中*/
  align-items: center;
  /*实现水平居中*/
  justify-content: center;
  text-align: justify;
  background-color: transparent;
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/favouratecell.vue